export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-wrench-d6d9a1ae73607b30293b95487f9440ab.svg";